import httpClient from ".";
import { API_ENDPOINTS } from "./endpoints";
import type {
  BalanceBillAttachmentRequest,
  BalanceBillAttachmentResponse,
  BalanceBillItemRequest,
  BalanceBillListRequest,
} from "@/model/balance-bill";

export const fetchBalanceBillList = async (
  balanceBillListPayload: BalanceBillListRequest,
) => {
  const url = API_ENDPOINTS.BALANCE_BILL.LIST_ALL_BILLS;
  const { token, ...payload } = balanceBillListPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Accept-Version": "1.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};

type BalanceBillRequestFormData = {
  formData: FormData;
  token: string;
};

export const uploadBalanceBill = async (
  requestData: BalanceBillRequestFormData,
) => {
  const url = API_ENDPOINTS.BALANCE_BILL.UPLOAD_BILL;
  const { formData, token } = requestData;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
      "Accept-Version": "1.0",
    },
  };
  return httpClient
    .post(url, formData, config)
    .then((response) => response.data);
};

export const fetchSingleBalanceBill = async (
  balanceBillItemRequest: BalanceBillItemRequest,
) => {
  const url = API_ENDPOINTS.BALANCE_BILL.SINGLE_BILL_INFO;
  const { token, ...payload } = balanceBillItemRequest;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Accept-Version": "1.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};

export const fetchSingleBalanceBillAttachment = async (
  balanceBillAttachmentRequest: BalanceBillAttachmentRequest,
) => {
  const url = API_ENDPOINTS.BALANCE_BILL.SINGLE_BILL_ATTACHMENT;
  const { token, ...payload } = balanceBillAttachmentRequest;
  const config = {
    responseType: "blob" as const,
    headers: {
      Authorization: `Bearer ${token}`,
      "Accept-Version": "1.0",
      "Content-Type": "application/json",
    },
  };

  return httpClient.post(url, payload, config).then((response) => {
    return {
      blob: response.data,
      contentType: response.headers["content-type"],
    } as BalanceBillAttachmentResponse;
  });
};
